/**
 * This file contains the list of all icons used in the application.
 * Add or remove icons here to manage which icons are available for use.
 *
 * After modifying this file, run the script: npm run icons:generate
 */

export const iconList = [
  // Material Symbols Icons
  'material-symbols:add',
  'logos:google-icon',
  'logos:microsoft-icon',
  'material-symbols:add-circle',
  'material-symbols:add-circle-outline',
  'material-symbols:add-photo-alternate',
  'material-symbols:add-photo-alternate-outline',
  'material-symbols:add-photo-alternate-rounded',
  'material-symbols:archive-outline',
  'material-symbols:arrow-back',
  'material-symbols:arrow-downward',
  'material-symbols:arrow-drop-down',
  'material-symbols:arrow-drop-up',
  'material-symbols:arrow-forward',
  'material-symbols:arrow-upward',
  'material-symbols:calendar-month',
  'material-symbols:calendar-today',
  'material-symbols:cancel',
  'material-symbols:check',
  'material-symbols:check-circle',
  'material-symbols:navigate-next',
  'material-symbols:navigate-before',
  'material-symbols:expand-less',
  'material-symbols:expand-more',
  'material-symbols:circle',
  'material-symbols:close',
  'material-symbols:content-copy',
  'material-symbols:delete',
  'material-symbols:delete-outline',
  'material-symbols:download',
  'material-symbols:drag-indicator',
  'material-symbols:edit',
  'material-symbols:edit-note',
  'material-symbols:error',
  'material-symbols:error-outline',
  'material-symbols:fast-forward',
  'material-symbols:forum',
  'material-symbols:hourglass-outline',
  'material-symbols:hourglass-empty',
  'material-symbols:description',
  'material-symbols:image',
  'material-symbols:image-outline',
  'material-symbols:menu',
  'material-symbols:more-horiz',
  'material-symbols:more-vert',
  'material-symbols:open-in-new',
  'material-symbols:open-with',
  'material-symbols:pause',
  'material-symbols:person',
  'material-symbols:play-arrow',
  'material-symbols:mobile-2-outline',
  'material-symbols:progress-activity',
  'material-symbols:public',
  'material-symbols:refresh',
  'material-symbols:remove',
  'material-symbols:rotate-right',
  'material-symbols:save',
  'material-symbols:science',
  'material-symbols:search',
  'material-symbols:select-all',
  'material-symbols:share',
  'material-symbols:star',
  'material-symbols:start',
  'material-symbols:sync',
  'material-symbols:translate',
  'material-symbols:tune',
  'material-symbols:undo',
  'material-symbols:upload',
  'material-symbols:upload-file',
  'material-symbols:visibility',
  'material-symbols:visibility-off',
  'material-symbols:workspace-premium',
  'material-symbols:zoom-in',
  'material-symbols:zoom-out',
  'material-symbols:filter-list',
  'material-symbols:info',
  'material-symbols:folder',
  'material-symbols:warning',
  'material-symbols:history',
  'material-symbols:language',
  'material-symbols:link',
  'material-symbols:list',
  'material-symbols:person-add',
  'material-symbols:person-remove',
  'material-symbols:publish',
  'material-symbols:quiz',
  'material-symbols:forum',
  'material-symbols:fast-forward',
  'material-symbols:mail',
  'material-symbols:logout',
  'material-symbols:lock',
  'material-symbols:event-available',
  'material-symbols:notifications',
  'material-symbols:chevron-right',
  'material-symbols:settings',
  'material-symbols:help',
  'material-symbols:home',
  'material-symbols:unfold-more',
  'material-symbols:emoji-events',
  'material-symbols:menu-book',
  'material-symbols:photo-library',
  'material-symbols:group',
  'material-symbols:side-navigation',
  'material-symbols:notifications-off',
  'material-symbols:task-alt',
  'material-symbols:cloud-upload',
  'material-symbols:auto-awesome',
  'material-symbols:mic',
  // Other Icons
  'ic:baseline-plus',
  'mdi:eye-off',
] as const;

// Type for icon names
export type IconName = typeof iconList[number];

// Function to validate if a string is a valid icon name
export function isValidIconName(name: string): name is IconName {
  return iconList.includes(name as IconName);
}
